export const ACTIONS = {
	AUTHENTICATE: "authenticate",
	ISMSUBSCRIBER: "IsmSubscriber",
};

export const ALL_QUERY_KEY = {
	GET_GROUPITEM_ASSETS: "get-groupitem-assets",
	GET_BANNERS: "get-banners",
	GET_CATEGORIES_BY_TYPE: "get-categories-by-type",
	GET_GROUPED_GROUPITEM_ASSETS: "get-grouped-groupitem-assets",
	GET_LATEST_ASSETS: "get-latest-assets",
	GET_GROUPITEM: "get-groupitem",
	GET_ORGANIZATION: "get-organization",
	GET_ASSET_PLAYBACK_URL: "get-asset-playback-url",
	GET_LIVE_EVENT_PLAYBACK_URL: "get-live-event-playback-url",
	GET_PORTAL: "get-portal",
	GET_USER_PROFILE: "get-user-profile",
	GET_USER_TICKET: "get-user-ticket",
	GET_ASSET: "get-asset",
	GET_ASSETS: "get-assets",
	GET_USER: "get-user",
	GET_USER_SUBSCRIPTION: "get-user-subscription",
};
